import script from "./EventTypePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./EventTypePicker.vue?vue&type=script&setup=true&lang=js"

import "./EventTypePicker.vue?vue&type=style&index=0&id=68d64f0e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68d64f0e"]])

export default __exports__